import React, { Component } from 'react';
import ApiParametersCreatorComponent from './ApiParametersCreatorComponent';
import ApiParametersListComponent from './ApiParametersListComponent';

class ApiParametersComponent extends Component {
  public render() {
    return (
      <div className={'flex flex-col w-full h-full mt-4'}>
        <ApiParametersCreatorComponent />
        <ApiParametersListComponent />
      </div>
    );
  }
}

export default ApiParametersComponent;
